import { Grid, TextField } from '@material-ui/core';
import {
  FormikErrors,
  FormikHandlers,
  FormikHelpers,
  FormikTouched,
} from 'formik';
import React from 'react';
import { AppNotificationDto } from '../../notifications.dto';

interface IProps {
  values: AppNotificationDto;
  errors: FormikErrors<AppNotificationDto>;
  touched: FormikTouched<AppNotificationDto>;
  handleChange: FormikHandlers['handleChange'];
  handleBlur: FormikHandlers['handleBlur'];
  setFieldValue: FormikHelpers<AppNotificationDto>['setFieldValue'];
}

const NotificationForm: React.FC<IProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <TextField
            size='small'
            margin='none'
            value={values.title || ''}
            label='Title'
            name='title'
            onChange={handleChange}
            onBlur={(e) => {
              handleBlur(e);
            }}
            error={Boolean(errors.title && touched.title)}
            helperText={Boolean(errors.title) && touched.title && errors.title}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size='small'
            margin='none'
            value={values.content || ''}
            label='Message'
            name='content'
            onChange={handleChange}
            onBlur={(e) => {
              handleBlur(e);
            }}
            error={Boolean(errors.content && touched.content)}
            helperText={
              Boolean(errors.content) && touched.content && errors.content
            }
            fullWidth
            required
          />
        </Grid>
      </Grid>
    </>
  );
};

export default NotificationForm;
